import HrFileCategoriesTable from 'components/tables/data/hr/HrFileCategoriesTable';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';

/** Route-level layout for the HR file-category table. */
export default function HrFileCategoriesPage() {
  return (
    <DashboardLayout height="screen" breadcrumbs={[{ title: 'Kategórie HR súborov' }]}>
      <HrFileCategoriesTable />
    </DashboardLayout>
  );
}
